module.exports = __webpack_public_path__ + "asset/image/mobile-operator-0e24.svg";